export class RecordingError extends Error {
  constructor(
    public message: string,
    private metricType: string,
    public originalError: Error | unknown | undefined = undefined,
  ) {
    super(message);
    this.name = this.constructor.name;
  }

  toDetails() {
    const details = {
      message: this.message,
      metricType: this.metricType,
      stack: this?.stack || 'unknown',
      originalError: this.originalError,
      originalErrorStack: 'unknown',
    };
    if (this.originalError && this.originalError instanceof Error && this.originalError.stack) {
      details.originalErrorStack = this.originalError.stack;
    }
    return details;
  }
}
